import { render, staticRenderFns } from "./ActivationV3Payments.vue?vue&type=template&id=2d82c136&scoped=true"
import script from "./ActivationV3Payments.vue?vue&type=script&lang=js"
export * from "./ActivationV3Payments.vue?vue&type=script&lang=js"
import style0 from "./ActivationV3Payments.vue?vue&type=style&index=0&id=2d82c136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82c136",
  null
  
)

export default component.exports